import React from 'react'

const SECTIONS = [
  {
    title: '1. Aceitação dos termos',
    body: 'Ao acessar e navegar neste site, você concorda com estes Termos de Uso. Se você não concordar com algum ponto, recomendamos que não utilize o site.',
  },
  {
    title: '2. Sobre o site',
    body: 'Este site é operado pela Dorac Agência e tem como objetivo apresentar nossos serviços, metodologia, cases e canais de contato para potenciais clientes e parceiros.',
  },
  {
    title: '3. Propriedade intelectual',
    body: 'Todo o conteúdo deste site (textos, identidade visual, logotipos, imagens e demais materiais) pertence à Dorac Agência ou é utilizado sob licença, sendo protegido por leis de direitos autorais e propriedade intelectual. É proibida a reprodução, distribuição ou uso comercial sem autorização prévia por escrito.',
  },
  {
    title: '4. Uso permitido',
    body: 'Você pode navegar e utilizar o site para fins pessoais e não comerciais, como conhecer nossos serviços e entrar em contato conosco. Não é permitido utilizar o site de forma que possa danificá-lo, sobrecarregá-lo ou comprometer sua segurança.',
  },
  {
    title: '5. Formulários e informações fornecidas',
    body: 'Ao preencher formulários de contato, você declara que as informações fornecidas são verdadeiras e atualizadas. O uso desses dados é regido pela nossa Política de Privacidade.',
  },
  {
    title: '6. Links para terceiros',
    body: 'Este site pode conter links para sites de terceiros (como redes sociais). Não nos responsabilizamos pelo conteúdo, práticas de privacidade ou disponibilidade desses sites externos.',
  },
  {
    title: '7. Limitação de responsabilidade',
    body: 'Fazemos o possível para manter as informações deste site atualizadas e precisas, mas não garantimos que estejam livres de erros. A Dorac não se responsabiliza por danos decorrentes do uso ou da impossibilidade de uso do site.',
  },
  {
    title: '8. Alterações destes termos',
    body: 'Podemos atualizar estes Termos de Uso a qualquer momento, sem aviso prévio. Recomendamos revisitar esta página periodicamente para se manter informado sobre eventuais mudanças.',
  },
  {
    title: '9. Legislação aplicável',
    body: 'Estes termos são regidos pelas leis brasileiras. Eventuais controvérsias serão resolvidas no foro da comarca do domicílio da Dorac Agência.',
  },
  {
    title: '10. Contato',
    body: 'S F Dorabiato de Matos LTDA (Agência Dorac), CNPJ 48.809.963/0001-67. Endereço: Rua Professora Diva Proença, 1855 - Sala 03 - Centro, Ivaiporã - PR, CEP 86870-174. E-mail: comercial@dorac.com.br. WhatsApp: +55 43 9665-9096.',
  },
]

function TermsOfUseContent() {
  return (
    <section className='dorac-grid-bg pb-24 pt-32'>
      <div className='container mx-auto max-w-3xl px-4'>
        <span className='section-eyebrow'>Transparência</span>
        <h1 className='section-title mb-6'>Termos de Uso</h1>
        <p className='mb-10 text-sm text-dorac-ink/50'>Última atualização: julho de 2026</p>

        <div className='flex flex-col gap-8'>
          {SECTIONS.map((section) => (
            <div key={section.title}>
              <h2 className='mb-2 text-lg font-bold text-dorac-ink'>{section.title}</h2>
              <p className='text-sm leading-relaxed text-dorac-ink/70'>{section.body}</p>
            </div>
          ))}
        </div>

        <div className='mt-12 border-t border-dorac-border pt-8'>
          <p className='text-sm text-dorac-ink/60'>
            Dúvidas sobre estes termos? Fale com a gente pelo e-mail{' '}
            <a href='mailto:comercial@dorac.com.br' className='font-semibold text-dorac-purple'>
              comercial@dorac.com.br
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  )
}

export default TermsOfUseContent
